import { c as _c } from "react/compiler-runtime";
export function RecaptchaDisclosure() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="underline hover:text-[var(--color-gray-600)]">Privacy Policy</a>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="mt-3 text-center text-[0.7rem] leading-snug text-[var(--color-gray-400)]">This site is protected by reCAPTCHA and the Google{" "}{t0}{" "}and{" "}<a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" className="underline hover:text-[var(--color-gray-600)]">Terms of Service</a>{" "}apply.</p>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}